export default function ByTheNumbers() {
  const stats = [
    {
      number: '6,000+',
      label: 'Private club members reached through partnership with Thousand Greens™',
      sublabel: '(and growing)',
    },
    {
      number: '1,000+',
      label: 'Dedicated Bucket List Series email club members',
      sublabel: '',
    },
    {
      number: '300+',
      label: 'Members-only private group participants',
      sublabel: '',
    },
    {
      number: '20+',
      label: 'Events in 2026 across the US and internationally',
      sublabel: '',
    },
  ];

  return (
    <section className="relative py-12 sm:py-16 lg:py-20 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center" 
        style={{ backgroundImage: 'url(https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/83c991c46e163da88d12844fa80e19b9.jpeg)' }}
      ></div>
      <div className="absolute inset-0 bg-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4">
            By the Numbers
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-yellow-400 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center"
            >
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-yellow-400 mb-2 sm:mb-3">
                {stat.number}
              </div>
              <div className="text-xs sm:text-sm md:text-base text-white font-medium leading-snug px-2">
                {stat.label}
              </div>
              {stat.sublabel && (
                <div className="text-xs md:text-sm text-white/80 mt-1 sm:mt-2 italic">
                  {stat.sublabel}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}